import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {AlmacenService} from "../../services/api/almacen.service";
import {MatTableDataSource} from "@angular/material/table";
import Swal from "sweetalert2";

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css']
})
export class StockComponent implements OnInit {

  menajeria:any=[];

  displayedColumns: string[] = [
    'id',
    'nombre',
    'marca',
    'modelo',
    'cantidad',
    'modificar',
    'eliminar'
  ];

  dataSource:any;


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(public dialog:MatDialog,private almacenService:AlmacenService) { }

  ngOnInit(){
    this.dataSource=new MatTableDataSource();
    this.getAllMenajeria();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort;
  }

  getAllMenajeria(){
    this.almacenService.getAllMenajeria().subscribe((response: {})=>{
      this.menajeria=response;
      this.dataSource.data = response;
      console.log(response)
      return response;
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogModify(i:number): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      nombre:this.menajeria[i].nombre,
      marca:this.menajeria[i].marca,
      modelo:this.menajeria[i].modelo,
      cantidad:this.menajeria[i].cantidad,
      title:"Modificar Artículo"
    };
    dialogConfig.width="50%";

    // let dialogRef = this.dialog.open(DialogMenajeriaComponent, dialogConfig);
    //
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(result);
    // });
  }
  openDialogAdd(): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      nombre:"",
      marca:"",
      modelo:"",
      cantidad:"",
      title:"Agregar Artículo"
    };
    dialogConfig.width="50%";

    // let dialogRef = this.dialog.open(DialogMenajeriaComponent, dialogConfig);
    //
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(
    //
    //   )
    // });
  }


  deleteArticulo(i:number): void {

    Swal.fire({
      title: 'Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          'Eliminado',
          'El registro se eliminó satisfactoriamente.',
          'success'
        )
        this.dataSource.data.splice(i, 1);
        this.dataSource._updateChangeSubscription();
      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("false");
      }
    })


  }

}
